/**
 * Reading the permission list the API returns.
 *
 * Extracted from the ReusableFunctionalities mixin so it can be used outside a component: the router
 * guard needs the same answer the templates get, and a mixin method is only reachable through `this`.
 * The mixin re-exports these, so its callers are unaffected.
 *
 * `routes` is the list from appAccessRules/allPath - one entry per rule code, carrying a boolean per
 * action.
 */

const findRule = (routes, code) =>
  (Array.isArray(routes) ? routes : []).find(item => item.pathCode === code)

export const checkRule = (routes, code, ruleType) => {
  const rule = findRule(routes, code)
  if (rule === undefined) return undefined

  switch (ruleType) {
    case 'view': return rule.view
    case 'add': return rule.add
    case 'edit': return rule.edit
    case 'deactivation': return rule.deactivation
    default: return undefined
  }
}

/**
 * Whether any rule whose code contains this fragment is viewable - used to decide whether a whole
 * section of the menu is worth drawing.
 */
export const hasGlobalRuleActive = (routes, codePart) =>
  (Array.isArray(routes) ? routes : [])
    .some(item => item.pathCode && item.pathCode.includes(codePart) && item.view)

/**
 * Whether the permission list allows this route.
 *
 * `matched` is the route chain vue-router resolved, so a detail page reached at /Problem/123 is
 * covered by the rule on its parent list without needing one of its own. Opening a page is always a
 * view: add, edit and deactivation gate controls inside it, never the door.
 */
export const canOpenRoute = (matched, permissions) =>
  (Array.isArray(matched) ? matched : [])
    .map(record => record.meta && record.meta.rule)
    .filter(Boolean)
    .every(rule => checkRule(permissions, rule, 'view') === true)
